import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";
import { api } from "@/lib/api";
import { useLiveRefresh } from "@/lib/live";
import { Warnings } from "@/components/meals/parts";

export default function TonightCard({ hub }) {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/organizations/${hub.id}/meals/tonight`).then(({ data }) => setD(data)).catch(() => {}), [hub.id]);
  useEffect(() => { load(); }, [load]);
  useLiveRefresh(load, (m) => (m.type || "").startsWith("meal.") || (m.type || "").startsWith("recipe."), null);
  if (!d) return null;
  return (
    <Link to={`/h/${hub.id}/meals`} className="q-card flex min-h-[44px] items-center gap-4 transition-transform hover:-translate-y-0.5" data-testid="tonight-card">
      <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[rgba(var(--glow-lists),0.15)] text-2xl">
        {d.dinner?.emoji || <UtensilsCrossed className="h-6 w-6 text-[rgb(var(--glow-lists))]" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] font-black uppercase tracking-[0.18em] text-[rgb(var(--glow-lists))]">Tonight's dinner</span>
        {d.dinner ? (
          <>
            <span className="block truncate font-display text-xl font-extrabold text-q-text" data-testid="tonight-dinner-name">{d.dinner.name}{d.dinner.cook_name ? ` · ${d.dinner.cook_name} cooks` : ""}</span>
            <Warnings items={d.dinner.warnings} compact testid="tonight-warning" />
          </>
        ) : (
          <span className="block font-semibold text-q-muted" data-testid="tonight-nothing">Nothing planned yet{d.can_edit && <span className="ml-2 text-sm text-[rgb(var(--glow-lists))] underline" data-testid="tonight-plan-link">Plan meals</span>}</span>
        )}
      </span>
    </Link>
  );
}
